import React from "react";
import Seo from "../components/shared/seo";
import Hero from "../components/comparePage/hero";
import Writer from "../components/comparePage/writer";
import Layout from "../components/shared/layout";
import { useIntl } from "gatsby-plugin-react-intl";

function Compare() {
  const intl = useIntl();

  return (
    <Layout>
      <Seo
        title={intl.formatMessage({
          id: "ComparePageTitle",
        })}
        description={intl.formatMessage({
          id: "ComparePageDescription",
        })}
      />
      <Hero />
      <Writer />
    </Layout>
  );
}

export default Compare;
